import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('Nieuwe versie beschikbaar! Wil je herladen?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App is klaar voor offline gebruik');
  },
});
